import { DateTime as DT } from 'luxon';
import { UserNameItem } from 'modules/user';
import ObjectStatusBadge from '../../../ObjectsList/ObjectStatus/ObjectStatusBadge';
import type { ObjectStatusHistoryRow } from '../model';

interface ObjectStatusHistoryTableRowProps {
    row: ObjectStatusHistoryRow;
}

const ObjectStatusHistoryTableRow = ({ row }: ObjectStatusHistoryTableRowProps) => {
    const date = DT.fromMillis(row?.dt || 0).toFormat('dd.MM.yyyy');
    const time = DT.fromMillis(row?.dt || 0).toFormat('HH:mm');

    return (
        <tr>
            <td className="event">
                <ObjectStatusBadge status={Number(row.status)} />
            </td>
            <td className="date">
                <span className="d-block">{date}</span>
                <span className="d-block text-muted fs-12">{time}</span>
            </td>
            <td className="username">
                <UserNameItem
                    smallMode
                    user={{
                        userName: row.userName,
                        userEmail: row.userEmail,
                        userPicture: row.userPicture || undefined,
                    }}
                />
            </td>
            <td className="comment">
                {row.comment ? (
                    <span className="history-price-comment">{row.comment}</span>
                ) : (
                    <span className="text-muted">—</span>
                )}
            </td>
        </tr>
    );
};

export default ObjectStatusHistoryTableRow;
